module.exports = __webpack_public_path__ + "img/smuze.1c8fef8b.jpg";